export default "__VITE_PUBLIC_ASSET__c75fdbc9__"